import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';
import './ServicesSection.css';

const solutions = [
  {
    image: '/illustrations/ai-automation.svg',
    title: 'AI & Intelligent Automation',
    desc: 'AI-powered data classification, document intelligence, analytics and intelligent business workflows.',
    to: '/services/artificial-intelligence-intelligent-automation',
  },
  {
    image: '/illustrations/gst-reconciliation.svg',
    title: 'Advanced GST Reconciliation',
    desc: 'Advanced GST reconciliation and automated data matching to simplify compliance and improve ITC reconciliation.',
    to: '/services/gst-reconciliation',
  },
  {
    image: '/illustrations/stock-market.svg',
    title: 'Stock Market Data Analysis',
    desc: 'Market intelligence using large-scale NSE and BSE trade data to identify abnormal patterns and market risks.',
    to: '/services/stock-market-data-analysis',
  },
  {
    image: '/illustrations/bank-narration.svg',
    title: 'Bank Narration Intelligence',
    desc: 'Transform complex bank statement narrations into structured, traceable and actionable financial intelligence.',
    to: '/services/bank-narration-intelligence',
  },
  {
    image: '/illustrations/dpdp-compliance.svg',
    title: 'DPDP Compliance & Data Privacy',
    desc: 'Data discovery, privacy governance, consent management and technology-enabled DPDP compliance.',
    to: '/services/dpdp-compliance',
  },
  {
    image: '/illustrations/call-centre.svg',
    title: 'Call Centre & Customer Service Automation',
    desc: 'AI-enabled customer communication, call workflows, query handling, follow-ups and service automation.',
    to: '/services/call-centre-customer-service-automation',
  },
  {
    image: '/illustrations/digital-marketing.svg',
    title: 'Digital Marketing & Customer Engagement',
    desc: 'Data-driven digital marketing, customer engagement, segmentation, campaigns and performance analytics.',
    to: '/services/digital-marketing-customer-engagement',
  },
  {
    image: '/illustrations/automation-process.svg',
    title: 'Automation & Process Digitisation',
    desc: 'Convert repetitive business processes into automated workflows with better speed, accuracy, scalability and control.',
    to: '/services/automation-process-digitisation-mis',
  },
];

const ServicesSection = () => (
  <section className="whatwedo-section">
    <div className="container">
      <motion.div
        className="whatwedo-header"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-60px' }}
        transition={{ duration: 0.55 }}
      >
        <span className="whatwedo-eyebrow">OUR SOLUTIONS</span>
        <h2 className="whatwedo-title">From Data to Real Impact.</h2>
        <p className="whatwedo-desc">
          Data Bolta Hai helps organisations collect, structure, analyse and automate complex business data.
        </p>
      </motion.div>

      <div className="whatwedo-grid">
        {solutions.map((s, i) => (
          <motion.div
            key={s.title}
            className="whatwedo-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-40px' }}
            transition={{ duration: 0.45, delay: i * 0.05 }}
          >
            <div className="whatwedo-card-img-wrapper">
              <img src={s.image} alt={s.title} className="whatwedo-card-img" />
            </div>
            <h3 className="whatwedo-card-title">{s.title}</h3>
            <p className="whatwedo-card-desc">{s.desc}</p>
            <Link to={s.to} className="whatwedo-card-link">
              Learn More <FiArrowRight />
            </Link>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="whatwedo-explore-wrapper"
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4, delay: 0.3 }}
      >
        <Link to="/services" className="whatwedo-explore-all">
          Explore All Solutions <FiArrowRight />
        </Link>
      </motion.div>
    </div>
  </section>
);

export default ServicesSection;
